export const THANK = 'cv-thank';
export const ACCEPTED_COOKIES = 'is_accepted_cookie';
export const UTM_SOURCE_ACCESSTRADE = 'accesstrade';
